import { mountStoreDevtool } from 'simple-zustand-devtools';
import { create } from 'zustand';

import { NearByV4Response, OfficeSearchApiResponse, SlotsSearchResponseV4 } from '@src/lib/__generated/api';

type State = {
	appointmentSlot: SlotsSearchResponseV4 | null;
	appointmentFacility: OfficeSearchApiResponse | NearByV4Response | null;
	appointmentNumber: string;
	invalidAppointment: boolean;
	previsitToken: string;
};

type Actions = {
	setAppointmentSlot: (slot: SlotsSearchResponseV4) => void;
	setAppointmentFacility: (facility: OfficeSearchApiResponse) => void;
	setAppointmentNumber: (appointmentNumber: string) => void;
	setInvalidAppointment: (invalidAppointment: boolean) => void;
	setPrevisitToken: (previsitToken: string) => void;
};

const useAppointmentStore = create<State & Actions>((set) => ({
	appointmentSlot: null,
	setAppointmentSlot: (appointmentSlot) => set({ appointmentSlot }),
	appointmentFacility: null,
	setAppointmentFacility: (appointmentFacility) => set({ appointmentFacility }),
	appointmentNumber: '',
	setAppointmentNumber: (appointmentNumber) => set({ appointmentNumber }),
	invalidAppointment: false,
	setInvalidAppointment: (invalidAppointment) => set({ invalidAppointment }),
	previsitToken: '',
	setPrevisitToken: (previsitToken) => set({ previsitToken }),
}));

if (process.env.NODE_ENV === 'development') {
	mountStoreDevtool('appointmentStore', useAppointmentStore);
}

export default useAppointmentStore;
